import DateFormat from '@/shared/utils/date-format';
import CancelItemRuleRequest from '../request/cancel-item-rule.request';
/* eslint-disable no-unused-expressions */
import ContractItem from './contract-item.entity';
import ContractVersionItemRule from './contract-version-item-rule.entity';
import DiscountItemRule from './discount-item-rule.entity';
import RevisionContractFlow from './contract-revision-flow.entity'
import FeeItemRule from './fee-item-rule.entity';

export default class ContractVersion {
  id: string;

  version: number;

  externalId: string;

  startedAt: string;

  observation: string;

  createdDate: string;

  createdBy: string;

  percentageReadjustment: number

  reviewed: boolean;

  eventsReview: Array<RevisionContractFlow>

  items?: Array<ContractItem>

  constructor(obj: any) {
    this.id = obj.id || ''
    this.version = obj.version || ''
    this.externalId = obj.externalId || ''
    this.startedAt = obj.startedAt || '';
    this.observation = obj.observation || ''
    this.createdDate = obj.createdDate || ''
    this.createdBy = obj.createdBy || ''
    this.percentageReadjustment = obj.percentageReadjustment || 0;
    this.reviewed = obj.reviewed || false;
    this.eventsReview = obj.eventsReview ? RevisionContractFlow.ofList(obj.eventsReview) : [];
    this.items = obj.items ? ContractItem.ofList(obj.items) : []
  }

  public static of(obj: any): ContractVersion {
    return new ContractVersion(obj || {});
  }

  public static ofList(obj: any[]): ContractVersion[] {
    return obj.map(this.of);
  }

  get filterItemsByMonthlyFrequency() {
    return this.items!!.filter((el: ContractItem) => el.isMonthly)
  }

  get itemRules() {
    const itemRules: any = [];
    this.items?.forEach((item: ContractItem, index: number) => {
      item.rules.forEach((rule: ContractVersionItemRule) => {
        itemRules.push({
          description: `ITEM ${item.number} - ${rule.ruleName}`,
          id: rule.contractItemRuleId,
          applyReadjustment: rule.applyReadjustment,
        })
      })
    })
    return itemRules
  }

  changeAllItemRulesState(state: boolean) {
    this.items?.forEach((item: ContractItem) => {
      item.rules.forEach((rule: ContractVersionItemRule) => {
        rule.applyReadjustment = state;
      })
    })
  }

  get discountItemRules(): DiscountItemRule[] {
    const discountItemRules: DiscountItemRule[] = [];
    this.items?.forEach((item: ContractItem) => {
      item.rules.forEach((rule: ContractVersionItemRule) => {
        discountItemRules.push(new DiscountItemRule({
          id: rule.contractItemRuleId,
          description: `ITEM ${item.number} - ${rule.ruleName}`,
          discount: rule.discount,
          discountType: rule.discountType,
          applyDiscount: rule.applyDiscount,
        }));
      });
    });
    return discountItemRules;
  }

  get feeItemRules(): FeeItemRule[] {
    const feeItemRules: FeeItemRule[] = [];
    this.items?.forEach((item: ContractItem) => {
      item.rules.forEach((rule: ContractVersionItemRule) => {
        feeItemRules.push(new FeeItemRule({
          id: rule.contractItemRuleId,
          description: `ITEM ${item.number} - ${rule.ruleName}`,
          fee: rule.fee,
          feeType: rule.feeType,
          applyFee: rule.applyFee,
        }));
      });
    });
    return feeItemRules;
  }

  get cancelItemRules(): CancelItemRuleRequest[] {
    const itemRules: any[] = [];
    this.items?.forEach((item: ContractItem, index: number) => {
      item.rules.forEach((rule: ContractVersionItemRule) => {
        itemRules.push({
          contractItemRuleId: rule.contractItemRuleId,
          description: `ITEM ${item.number} - ${rule.ruleName}`,
          billingStrategy: '',
          billingValue: '',
        });
      });
    });
    return itemRules;
  }

  lastContractRevisionEvent(): RevisionContractFlow {
    if (this.eventsReview.length === 0) {
      return new RevisionContractFlow({ state: 'PENDING' })
    }
    return this.eventsReview[this.eventsReview.length - 1];
  }
}
